import React, {useRef, useState} from 'react';
import { action, observable } from "mobx";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import CommonUtil from 'utils/CommonUtil';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import DateUtil from "utils/DateUtil";
import UI from "../../../../components/UI";


function ManualContainer() {
    const history = useHistory();
    const location = useLocation();
    const [boardList, setBoardList] = useState<any[]>([]);
    const [totalCnt,setTotalCnt] = useState(0);
    const [searchDivCd, setSearchDivCd] = useState('0'); // 제목/내용 선택
    const [searchText, setSearchText] = useState('');
    const [notiTpCd, setNotiTpCd] = useState('F');

    // 페이징 설정
    const [pageNum, setPageNum] = useState(1);      // 페이지 번호
    const [pageSize, setPageSize] = useState(9);    // 화면에 출력할 목록 갯수(10개)
    const pageCnt = useRef<any>(0);                 // 페이지 갯수

    //초기 데이터 설정
    let data = {};
    let param = {};

    const handleSelect = (e) => {
       if(e.target.name === 'searchDivCd'){
          setSearchDivCd(e.target.value);
       }
    };

    async function getRead() {

        param = {
            SEARCH_DIV_CD: searchDivCd,
            SEARCH_TEXT: searchText,
            NOTI_TP_CD : notiTpCd,
            PAGE_NUM: pageNum,
            PAGE_SIZE: pageSize
        };

        const response:any = await CommonUtil.execute({
            url: 'usr_2300.jct',
            data: param
       }).then((response:any) => {
           data = response.REC;

           setBoardList(response.REC);
           // 전체ROW개수
           setTotalCnt(response.TOTAL);
           // 페이징 갯수
           let totCnt = response.TOTAL;
           let rowCnt = pageSize;
           pageCnt.current = Math.floor((totCnt % rowCnt) == 0 ? totCnt / rowCnt : totCnt / rowCnt + 1);
       }).catch(err => {
           CommonUtil.showAxiosError(err);
           return;
       });

    }

    //인풋 엔터체크
    const activeEnter = (e) => {
        if(e.key === "Enter") {
            getRead();
        }
    }

    async function pageMove(notiNo) {
        let dataToSend = {NOTI_NO : notiNo};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './usr_2303',
          state: { data: dataToSend }
        });
    }

    React.useEffect(() => {

        getRead();

    }, [pageNum])//effect


    // 제목 텍스트 입력 후 엔터 시 리로딩 방지
    const submitHnadler = (e) => {
        e.preventDefault();
    }


	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
			<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">고객지원</Link></li>
					<li><Link to="#">자주묻는질문</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">자주묻는질문(FAQ)</h1>
					<form name="" action="" method="" onSubmit={submitHnadler}>
						<div className="tb-search-form">
							<div className="tb-search-items">
								<div className="sl sl-big">
									<select name="searchDivCd" id="searchDivCd" value={searchDivCd} onChange={handleSelect}>
                                        <option value='0'>전체</option>
                                        <option value='1'>제목</option>
                                        <option value='2'>내용</option>
									</select>
								</div>
								<UIInput className="hz-item tf tf-big" placeholder={"입력하세요"} value={searchText} valueChanged={(value) => setSearchText(value)} onKeyEnter={(e) => activeEnter(e)}/>
							</div>
							<button type="button" className="hz-item bt bt-big bt-pri" onClick={getRead}>검색</button>
						</div>
					</form>
					<div className="tb">
						<div className="tb-top">
							<div>
								<p className="tx fc-black">
									총 <em className="fw500 fc-pri">{totalCnt}</em>건의 게시물이 있습니다
									(<em className="fw500 fc-pri">{pageNum}/{pageCnt.current < 1 ? 1 : pageCnt.current}</em> 페이지)
								</p>
							</div>
						</div>
						<table>
							<caption>게시판 목록</caption>
							<colgroup>
								<col width="90px" />
								<col />
								<col width="120px" />
								<col width="140px" />
								<col width="120px" />
							</colgroup>
							<thead>
								<tr>
									<th scope="col">번호</th>
									<th scope="col">제목</th>
									<th scope="col">작성자</th>
									<th scope="col">등록일</th>
									<th scope="col">조회수</th>
								</tr>
							</thead>
							<tbody>
								{boardList != null ? (
                                    boardList.map((board, index) => (
                                        index <= 9 &&
                                        <tr key={board.NOTI_NO}>
                                            <td>{board.ROWNUM}</td>
                                            <td className="ta-left">
                                                <a href="#" onClick={(e) => {e.preventDefault(); pageMove(board.NOTI_NO);}} className="tx tx-bd2 tx-link">{board.NOTI_TITLE}</a>
                                            </td>
                                            <td>{board.REG_USER_NM}</td>
                                            <td>{DateUtil.toDateFormat(board.REG_DATE, "YYYY-MM-DD")}</td>
                                            <td>{board.RET_CNT}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                      <td colSpan={6} className="text-center">
                                        게시물이 없습니다
                                      </td>
                                    </tr>
                                )}
							</tbody>
						</table>
					</div>

					<UI.PaginationBar
                        totalCnt={totalCnt}
                        rowCnt={10}
                        currentPage={pageNum}
                        onChange={(current:number) => {
                            setPageNum(current);
                        }}
                    />

				</main>
			</div>
		</PageContainer>
	);
}
export default ManualContainer;